

(function () {
  function shortenLabel(s) {
    if (!s) return s;
    s = s.trim();
    if (/^newborn$/i.test(s))                    return 'NB';
    s = s.replace(/(\d+)-(\d+)\s*months?/i,      '$1-$2M');
    s = s.replace(/^(\d+)\s*months?$/i,          '$1M');
    s = s.replace(/(\d+)-(\d+)\s*years?/i,       '$1-$2Y');
    s = s.replace(/^(\d+)\s*years?$/i,           '$1Y');
    return s;
  }

  function applyShortLabels(root) {
    root = root || document;
    root.querySelectorAll('.wrapper-item-size .sizes-list .size-item a').forEach(function (a) {
      var original = a.getAttribute('title') || a.textContent.trim();
      a.textContent = shortenLabel(original);
    });
  }

  /* Run on load */
  document.addEventListener('DOMContentLoaded', function () {
    applyShortLabels();
  });

  /* Also watch for dynamic renders (AJAX / recommendations loading) */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) applyShortLabels(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();